import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { SolutionCenterContentTypes, ZendeskArticle, ZendeskSection } from '../../../types/solution-center';
import { GetZendeskArticlesBySectionId } from '../../../connection/zendesk';
import {
	LoadingContainer,
	SectionContainer,
	SectionHeader,
	SectionList,
	SectionListItem,
} from '../elements';
import { setSolutionCenterContentState } from '../../../stores/actions/user-interface';
import PaginationControls from '../pagnation-controls';
import LoadingSpinner, { LoadingSpinnerType } from '../../general-components/loading-spinner';

const ARTICLE_LIMT = 25;

interface SectionViewProps {
	currentSection: ZendeskSection;
}

export default function SectionView({ currentSection }: SectionViewProps) {
	const dispatch = useDispatch();

	const [sectionArticles, setSectionArticles] = useState<ZendeskArticle[]>([]);
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [totalPages, setTotalPages] = useState<number>(1);
	const [currentPage, setCurrentPage] = useState<number>(1);

	const handleGetArticles = async (page: number) => {
		setIsLoading(true);
		GetZendeskArticlesBySectionId(currentSection.id, ARTICLE_LIMT, page).then((res) => {
			if (typeof res.page === 'number') setCurrentPage(res.page);
			if (typeof res.page_count === 'number') setTotalPages(res.page_count);
			if (res.articles) setSectionArticles(res.articles);
			setIsLoading(false);
		});
	};

	useEffect(() => {
		handleGetArticles(1); // load the first page of articles when the section changes
	}, [currentSection]);

	return (
		<>
			{isLoading ? (
				<LoadingContainer>
					<LoadingSpinner
						height={36}
						width={36}
						type={LoadingSpinnerType.Gradient}
						style={{ background: '#26242B' }}
					/>
				</LoadingContainer>
			) : (
				<div>
					<SectionContainer className="section-view">
						<SectionHeader>{currentSection.name}</SectionHeader>
						<SectionList>
							{sectionArticles.map((article) => (
								<SectionListItem
									key={`article-${article.id}`}
									onClick={() => dispatch(setSolutionCenterContentState({
										id: article.id,
										type: SolutionCenterContentTypes.Article,
									}))}
								>
									{article.title}
								</SectionListItem>
							))}
						</SectionList>
					</SectionContainer>
				</div>
			)}
			<PaginationControls
				isLoading={isLoading}
				currentPage={currentPage}
				totalPages={totalPages}
				onPageChange={(newPage: number) => {
					handleGetArticles(newPage);
				}}
			/>
		</>
	);
}
